import './styles.scss';

export function Loading() {
  return (
    <div className="loading-container">
      <div className="circle"></div>
    </div>
  );
}